import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Filtros from "@Composicion/Filtros/Filtros";

import MPDFRegistroComprobante from "@RegistrosComprobantes/Modales/MPDFRegistroComprobante";

// import MAgregarEditarRegistrosComprobantes from "@ConfiguracionSistema/Sistema/RegistrosComprobantes/Modales/MAgregarEditarRegistrosComprobantes";
// import MEliminarEditarRegistrosComprobantes from "@ConfiguracionSistema/Sistema/RegistrosComprobantes/Modales/MEliminarEditarRegistrosComprobantes";

import "./RegistrosComprobantes.css";
function RegistrosComprobantes() {
  const origenComponente = "RegistrosComprobantes";
  const { ecv_u, cv_u, usuarioSesion, esComputadora, rolUsuarioSesion } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},
    da_empresas: [],

    d_fechaInicio: "",
    d_fecha_fin: "",
    d_codEmpresa: "",
    d_tipoComprobante: "",
  });

  useEffect(() => {
    const componenteInstaladoAPI = _api_.f_boletas_facturas({
      parametros: {
        fecha_inicio: v_u.d_fechaInicio,
        fecha_fin: v_u.d_fecha_fin,
        empresa: v_u.d_codEmpresa,
        tipo_comprobantes: v_u.d_tipoComprobante,
      },
      origen: origenComponente,
      timeout: 5000,
    });

    componenteInstaladoAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          do_datosTabla: dPC.contenido,
          do_filtros: dPC.contenido.filtros,
          da_grid: dPC.contenido.grid,
          da_headgrid: dPC.contenido.headgrid,
          d_multiselecion: dPC.contenido.multiselection,
        });
      }
    });
  }, [recargaComponente]);

  useEffect(() => {
    const empresasAPI = _api_.f_listarEmpresas({
      parametros: { codigo: null, activo: "S", propietaria: "S" },
      origen: origenComponente,
      timeout: 20000,
    });

    empresasAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          da_empresas: dPC.contenido.empresa,
        });
      }
    });
  }, []);

  return (
    <div className={"RegistrosComprobantesCSS-contenedor"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false });
          }}>
          {/* <MAgregarEditarRegistrosComprobantes
            registro={{
              codigo: "",
            }}
            fCerrarComponente={() => {
              _f_.asignar(ev_c, { modal_mostrar: false });
            }}
            fActualizarTablaTotal={(actualizar) => {
              if (actualizar) {
                erecargaComponente((prev) => !prev);
              }
            }}
          /> */}
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Registro de Comprobantes"}</div>
      <div className={"RegistrosComprobantesCSS-cabecera"}>
        <div className={"RegistrosComprobantesCSS-c-inputs"}>
          {false && ["SADM01"].includes(rolUsuarioSesion) && (
            <_div_.Div2
              estilos={{ fuente: "1.5rem" }}
              texto={`Total Facturado: ${_f_.formatearValor({ valor: v_u.d_deudaTotal, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
            />
          )}
          {!["DIST01", "ADIST01"].includes(rolUsuarioSesion) && (
            <_opt_.Opcion2
              texto="Tipo de Comprobante"
              clave={["Tipo"]}
              valor={["Valor"]}
              opciones={
                [
                  { Tipo: 1, Valor: "Boletas" },
                  { Tipo: 2, Valor: "Facturas" },
                ] || []
              }
              name={String(Math.random())}
              estilos={{ width: "15rem" }}
              seleccionado={v_u.d_codigoDistribuidor}
              onBlur={(evento) => {
                // console.log(evento.target.getAttribute("value"));
                // console.log(evento.target.value);
                _f_.asignar(ev_u, { d_tipoComprobante: evento.target.getAttribute("value") });
              }}
            />
          )}
          <_opt_.Opcion2
            texto="Empresa"
            clave={["codigo"]}
            valor={["nombre"]}
            opciones={v_u.da_empresas || []}
            name={String(Math.random())}
            estilos={{ width: "15rem" }}
            seleccionado={v_u.d_codigoAyudante}
            onBlur={(evento) => {
              _f_.asignar(ev_u, { d_codEmpresa: evento.target.getAttribute("value") });
            }}
          />
          <_ipt_.Input4
            tipo={"date"}
            texto={"Fecha Inicio"}
            estilos={{ width: "15rem" }}
            onBlur={(evento) => {
              // console.log(evento.target.value);
              _f_.asignar(ev_u, { d_fechaInicio: evento.target.value });
            }}
          />
          <_ipt_.Input4
            tipo={"date"}
            texto={"Fecha Fin"}
            estilos={{ width: "15rem" }}
            onBlur={(evento) => {
              // console.log(evento.target.value);
              _f_.asignar(ev_u, { d_fecha_fin: evento.target.value });
            }}
          />
        </div>
        <div className={"RegistrosComprobantesCSS-c-buscar"}>
          <_btn_.Boton
            texto={`Buscar`}
            tipo="btn-2"
            estilos={{
              anchoB2: "10rem",
              color: "var(--color_verde_1)",
              fuente: "1rem",
            }}
            onClick={() => {
              erecargaComponente((prev) => !prev);
              /*
              d_fechaInicio: "",
              d_fecha_fin: "",
              d_codEmpresa: 0,
              d_tipoComprobante: "",
              */
              // erecargaComponente((prev) => !prev);
              // _f_.asignar(ev_c, {
              //   modal_mostrar: true,
              //   modal_titulo: "Agregar Producto Producción",
              //   modal_estilos: { anchoMI: "40rem", altoMI: "initial" },
              // });
            }}
          />
        </div>
      </div>
      <Filtros
        filtros={v_u.do_filtros}
        funcionObtenerValores={(valores) => {
          _f_.asignar(ev_u, { do_filtrosActualizados: valores });
        }}
      />
      <_tabla_.Tabla
        origen={origenComponente}
        cabecera={v_u.da_headgrid}
        registros={v_u.da_grid}
        filtros={v_u.do_filtrosActualizados}
        modoVista={"modo1"}
        permiteVerCategoriaCompleta={false}
        permiteMultiseleccion={v_u.d_multiselecion}
        permiteOpciones={true}
        opcionesPorDefecto={0b00_000_000}
        camposCodigosSeleccion={["codigo"]}
        campoCodigoCategoria={"categoria"}
        campoCodigoRegistrosPorCategoria={"registros"}
        campoOpcionesTablaInterna={"opcionesTablaInterna"}
        // datosComplementarios={{
        //   codigoPrecioVenta: v_u.d_codigoDistribuidor,
        //   ...v_u.do_datosTabla,
        // }}
        reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
        mapaDeComponentes={
          {
            MPDFRegistroComprobante,
            // MEliminarEditarRegistrosComprobantes,
          }
        }
        fObtenerSeleccionados={(seleccionados) => {
          _f_.asignar(ev_u, { do_seleccionados: seleccionados });
        }}
        fNotificarActualizacionDeTabla={(actualizar) => {
          if (actualizar) {
            erecargaComponente((prev) => !prev);
          }
        }}
        fObtenerDatosParcialesActualizados={(datos) => {
          console.log(datos);
          _f_.asignar(ev_u, { d_totalSolicitado: datos?.total_pedido });
        }}
      />
      {false && (
        <div className="RegistrosComprobantesCSS-opciones">
          <_btn_.Boton
            texto="Agregar Programa o Imagen"
            tipo="btn-2"
            estilos={{ anchoB2: "10rem", color: "#4e942e" }}
            // procesando={v_u.v_formulario}
            onClick={() => {
              _f_.asignar(ev_c, {
                modal_mostrar: true,
                modal_titulo: "Agregar Programa o Imagen",
                modal_estilos: { anchoMI: "40rem", altoMI: "initial" },
              });
            }}
          />
        </div>
      )}
    </div>
  );
}
export default RegistrosComprobantes;
